// Linked product selector - reads the hidden sibling list rendered by
// linked-product-selector.liquid and, when a Length/Paper click resolves to
// a unique matching sibling product, navigates the browser there. This is
// the same "separate products glued together by a picker" pattern
// competitors use - each option is a genuinely different Shopify product
// page, not an in-place variant swap.
//
// Not every Length x Paper combination necessarily exists (a color might
// only have been made in a few sizes) - same as native Shopify variant
// pickers, any option that has no valid product for the OTHER dimension's
// current selection is grayed out and inert rather than clickable-but-does-
// nothing.
if (!window.linkedProductSelectorWired) {
  window.linkedProductSelectorWired = true;

  function initLinkedProductSelector(wrapper) {
    var dataItems = Array.prototype.slice.call(wrapper.querySelectorAll('.linked-product-selector__data li'));
    if (!dataItems.length) return;

    var siblings = dataItems.map(function (li) {
      return {
        length: li.dataset.length || '',
        paper: li.dataset.paper || '',
        url: li.dataset.url || '',
        available: li.dataset.available === 'true',
        requestQuote: li.dataset.requestQuote === 'true',
      };
    });

    var lengthGroup = wrapper.querySelector('[data-option-group="length"]');
    var paperGroup = wrapper.querySelector('[data-option-group="paper"]');

    var state = {
      length: lengthGroup ? (lengthGroup.querySelector('[data-current-value]').textContent || '').trim() : '',
      paper: paperGroup ? (paperGroup.querySelector('[data-current-value]').textContent || '').trim() : '',
    };

    function findMatch() {
      return siblings.find(function (s) {
        var lengthOk = !lengthGroup || s.length === state.length;
        var paperOk = !paperGroup || s.paper === state.paper;
        return lengthOk && paperOk;
      });
    }

    function setPressed(group, value) {
      if (!group) return;
      group.querySelectorAll('[data-type]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.value === value ? 'true' : 'false');
      });
      var label = group.querySelector('[data-current-value]');
      if (label) label.textContent = value;
    }

    // Grays out (and disables) any Paper button that has no sibling at the
    // currently selected Length, and vice versa - exactly like a native
    // Shopify variant picker disabling combinations that don't exist.
    function updateAvailability() {
      if (paperGroup) {
        paperGroup.querySelectorAll('[data-type="paper"]').forEach(function (btn) {
          var val = btn.dataset.value;
          var available = !lengthGroup || siblings.some(function (s) {
            return s.paper === val && s.length === state.length;
          });
          btn.classList.toggle('linked-product-selector__swatch--unavailable', !available);
          btn.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      }

      if (lengthGroup) {
        lengthGroup.querySelectorAll('[data-type="length"]').forEach(function (btn) {
          var val = btn.dataset.value;
          var available = !paperGroup || siblings.some(function (s) {
            return s.length === val && s.paper === state.paper;
          });
          btn.classList.toggle('linked-product-selector__btn--unavailable', !available);
          btn.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      }

      updateQuoteIndicators();
    }

    // Flags any option that would resolve to a quote-only sibling (its
    // "Request a Quote" metafield is true) BEFORE the shopper clicks it -
    // clicking navigates immediately once a match is found, so a shopper
    // never actually sees an "after you land" state on this page. Without
    // this, switching Length/Paper could silently swap them from a normal
    // priced product into a quote-only one with zero warning.
    //
    // The Length x Paper combination doesn't always uniquely identify one
    // sibling - some families link products that differ in a dimension this
    // picker doesn't render a control for (e.g. two colors sharing one
    // paper_type/color metafield value, so the Paper group never renders,
    // yet both are in the family). When that happens, a plain sibling
    // lookup can silently grab the WRONG one. The button representing the
    // page's own current product is never ambiguous - it's flagged
    // directly from the wrapper's own data attributes (the real product's
    // own metafield, read server-side) rather than searched for.
    function updateQuoteIndicators() {
      var currentRequestQuote = wrapper.dataset.currentRequestQuote === 'true';

      function siblingFor(type, val) {
        return siblings.find(function (s) {
          var lengthOk = type === 'length' ? s.length === val : (!lengthGroup || s.length === state.length);
          var paperOk = type === 'paper' ? s.paper === val : (!paperGroup || s.paper === state.paper);
          return lengthOk && paperOk;
        });
      }

      function isQuoteOnly(type, val) {
        var isCurrentValue = type === 'length'
          ? (val === wrapper.dataset.currentLength && (!paperGroup || state.paper === wrapper.dataset.currentPaper))
          : (val === wrapper.dataset.currentPaper && (!lengthGroup || state.length === wrapper.dataset.currentLength));
        if (isCurrentValue) return currentRequestQuote;
        var match = siblingFor(type, val);
        return !!(match && match.requestQuote);
      }

      if (lengthGroup) {
        lengthGroup.querySelectorAll('[data-type="length"]').forEach(function (btn) {
          var quoteOnly = isQuoteOnly('length', btn.dataset.value);
          btn.classList.toggle('linked-product-selector__btn--quote-only', quoteOnly);
          btn.title = quoteOnly ? 'Quote required for this option' : '';
        });
      }

      if (paperGroup) {
        paperGroup.querySelectorAll('[data-type="paper"]').forEach(function (btn) {
          var quoteOnly = isQuoteOnly('paper', btn.dataset.value);
          btn.classList.toggle('linked-product-selector__swatch--quote-only', quoteOnly);
          if (quoteOnly) {
            var tooltip = btn.querySelector('.linked-product-selector__swatch-tooltip');
            if (tooltip && tooltip.textContent.indexOf('Quote required') === -1) {
              tooltip.textContent += ' · Quote required';
            }
          }
        });
      }
    }

    function handleClick(type, value) {
      if (type === 'length') state.length = value;
      if (type === 'paper') state.paper = value;
      setPressed(type === 'length' ? lengthGroup : paperGroup, value);
      updateAvailability();

      var match = findMatch();
      if (!match || !match.url) return;

      var targetPath;
      try {
        targetPath = new URL(match.url, window.location.origin).pathname;
      } catch (e) {
        targetPath = match.url;
      }
      if (targetPath && targetPath !== window.location.pathname) {
        window.location.href = match.url;
      }
    }

    wrapper.querySelectorAll('[data-type="length"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        handleClick('length', btn.dataset.value);
      });
    });

    wrapper.querySelectorAll('[data-type="paper"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        handleClick('paper', btn.dataset.value);
      });
    });

    updateAvailability();
  }

  document.querySelectorAll('.linked-product-selector').forEach(initLinkedProductSelector);
}
